import React from 'react'
import {composeComponent} from 'utils/react-tools'
import Questions from './Questions'


export default composeComponent 'Questions.Prework',
  (props) ->
    React.createElement(Questions, Object.assign({},  props, {"prework": (true)}))